/**
* @typedef {import("@/src/types/diy-bundle").DiyBundleSetItem} SetItem
* @typedef {import("@/src/types/diy-bundle").DiyBundleRef} Ref
* @typedef {import("@/src/types/diy-bundle").DiyBundleSectionData} SectionData
* @typedef {import("@/src/types/diy-bundle").DiyBundleProductsGroup} ProductsGroup
* @typedef {import("@/src/types/diy-bundle").DiyBundleFilterParticipateDiscountSetItemsReturn} FilterParticipateDiscountSetItemsReturn
*/
if (!customElements.get('diy-bundle')) {
  customElements.define('diy-bundle', class DiyBundle extends HTMLElement {
    /** 
     * 代理源 
     * @type {Ref}
     * */
    _refOrigin = {
      /** 当前选择的产品 */
      currentSet: [],
    };
    /**
     * @type {Ref}
     * */
    ref;
    addCartButtonEnable = false;

    constructor() {
      super();
      this.init();
    }

    init() {
      try {
        /** @type {SectionData} */
        this.sectionData = JSON.parse(this.querySelector('[data-section-json]')?.innerHTML.replaceAll('\n', '').replaceAll(',]', ']'));
        this.themeTranslate = this.sectionData.translate;
        // 阶梯折扣进行排序
        this.sectionData.discount_step.sort((a, b) => a.count - b.count);
      } catch (error) {
        this.themeTranslate = {};
        this.sectionData = {};
        console.error(error);
      }

      // 代理
      const proxyHander = {
        get(target, key) {
          return target[key];
        },
        set: (target, property, value) => {
          target[property] = value;
          this.render(target, property, value);
          return true;
        },
      };
      const ref = new Proxy(this._refOrigin, proxyHander);
      this.ref = ref;
      this.formContainer = document.querySelector("[data-set-form-container]");
      this.setItemsSwiperElement = document.querySelector("[data-set-items-swiper]");
      this.setItemsElement = this.querySelector('[data-set-items]');
      this.addCartButton = this.querySelector('[data-add-to-cart]');
      this.addCartButtonDot = this.addCartButton.querySelector('[data-add-to-cart-dot]');
      this.addCartButtonPrice = this.addCartButton.querySelector('[data-button-price]');
      this.addCartButtonComparePrice = this.addCartButton.querySelector('[data-button-compare-price]');
      this.drawer = document.querySelector("[data-drawer='drawer-cart']");
      this.klarna = this.querySelector("klarna-placement");
      this.paypal = this.querySelector("[data-pp-amount]");
      this.expandToggleButton = this.querySelector('[data-expand-toggle-button]');
      this.expandToggleTarget = this.querySelector('[data-expand-toggle-target]');
      this._onExpandToggleClick = this.toggleFormExpand.bind(this);

      this.initEvent();
      this.applySetFromUrl();
      this.render(this._refOrigin);
    }

    initEvent() {
      // 媒体查询
      const isMobile = '(max-width: 767px)';
      const isMobileMQL = window.matchMedia(isMobile);
      this.isMobileMQL = isMobileMQL;
      isMobileMQL.addEventListener('change', (event) => {
        event.matches ? this.mediaChangeToMobile() : this.mediaChangeToPc();
      });
      isMobileMQL.matches ? this.mediaChangeToMobile() : this.mediaChangeToPc();

      // 已选产品Set最小数量跟随设备尺寸变化
      window.matchMedia('(max-width:589px) or ((max-width:1180px) and (min-width:768px))')
        .addEventListener('change', (event) => {
          this.render(this._refOrigin);
        });

      // Add to set 全局监听
      document.addEventListener('theme:upsell:add_to_set', (e) => {
        const variantId = e.detail.variant_id;
        const product = !!e.detail.jsonString ? JSON.parse(e.detail.jsonString) : undefined;
        if (!!variantId) console.warn('theme:upsell:add_to_set: has not variantId');
        if (!!product) console.warn('theme:upsell:add_to_set: has not jsonString');
        const variant = product.variants.find((v) => v.id == variantId);
        this.ref.currentSet.push(this.createSetItem(variantId, product, variant));
        this.ref.currentSet = this.ref.currentSet;
        // 加入 Your Set 后展开悬浮表单（移动端）
        if (this.isMobileMQL?.matches && this.formContainer && !this.formContainer.classList.contains('expanded')) {
          this.setFormExpanded(true, true);
        }
        // 不论是否展开，轮播都滑到最后一项
        this.slideSetItemsToLast();
      })

      // 删除产品
      this.setItemsElement.addEventListener("click", (e) => {
        /** @type {HTMLElement} */
        const target = e.target;
        if (target.closest('[data-set-item-remove]')) {
          const index = Number(target.closest('[data-index]')?.getAttribute('data-index'));
          if (!isNaN(index)) {
            this.ref.currentSet.splice(index, 1);
            this.ref.currentSet = this.ref.currentSet;
          }
        }
      });

      // 加购
      this.addCartButton.addEventListener("click", (e) => {
        e.target.classList.add("loading");
        const items = this.ref.currentSet.map((v) => {
          return {
            id: v.variantId,
            quantity: 1,
          }
        });
        if (items.length == 0) return;
        this.addToCart(items).then(async (added) => {
          if (added) this.trackBundleVirtualSkuAddToCart();
          const cartResponse = await fetch(`${window.theme.routes.cart}.js`);
          if (!cartResponse.ok) {
            throw cartResponse;
          }
          const cart = await cartResponse.json();
          document.dispatchEvent(
            new CustomEvent('theme:cart:change', {
              detail: { cart },
              bubbles: true,
            })
          );
          if (this.drawer) {
            this.drawer.dispatchEvent(
              new CustomEvent('theme:drawer:toggle', {
                bubbles: false,
              })
            );
          }
        }).catch((error) => {
          console.log('[Diy Bundle] Add to Cart Error:', error.ok, error.status, error.statusText, error);
          const simpleToast = document.getElementById('simple-toast');
          simpleToast.showResponseError(error);
        }).finally(() => e.target.classList.remove("loading"));
      });

      // 滚动：顶部隐藏整个悬浮表单，滚过后再滑出
      window.addEventListener('scroll', () => {
        if (window.scrollY > 100) {
          this.formContainer?.classList.add('active');
        } else {
          this.formContainer?.classList.remove('active');
        }
      });

      this.expandToggleButton?.addEventListener('click', this._onExpandToggleClick);

      // 点击产品卡片链接会弹出 Quickview 弹窗
      this.addEventListener('click', (e) => {
        const gridItem = e.target?.closest('[data-grid-item], .product-grid-item');
        const swatchButtonMore = e.target?.closest('[data-swatch-button-more]');
        const upsellButton = gridItem?.querySelector('.product-grid-item__btn');
        if (swatchButtonMore && upsellButton) {
          upsellButton.click();
          e.preventDefault();
          return;
        }
        const gridItemLink = e.target?.closest('[data-grid-item] a, .product-grid-item a');
        if (gridItemLink) {
          const slide = gridItemLink.closest('[data-product-handle]');
          const productHandle = slide.getAttribute('data-product-handle');
          if (productHandle) {
            window.theme.dialogs?.openQuickview(productHandle, this.getGridItemVariantId(gridItemLink));
            e.preventDefault();
          }
          return;
        }
      });
    }

    /**
     * 从卡片当前选中变体或链接上的 ?variant= 读取变体 id。
     * @param {HTMLAnchorElement} gridItemLink
     * @returns {string|number|undefined}
     */
    getGridItemVariantId(gridItemLink) {
      const gridItem = gridItemLink.closest('product-grid-item-v3');
      if (gridItem?.variant?.id) return gridItem.variant.id;

      const href = gridItemLink.getAttribute('href');
      if (!href) return undefined;
      try {
        return new URL(href, window.location.origin).searchParams.get('variant') || undefined;
      } catch {
        return undefined;
      }
    }

    /** 代理发生变化
     * @param {Ref} target 
     */
    render(target, property, value) {
      /** 是否允许多个相同产品参与折扣 (A+A) */
      const supportSameMultiProduct = this.sectionData.support_A_A;
      // 已选 Set 中参与折扣的项、不参与折扣的项、参与折扣的产品
      const { participateDiscountSetItems, _, participateDiscountsNoSameProducts } = this.filterParticipateDiscountSetItems(target.currentSet, supportSameMultiProduct);
      /** 计算折扣 */
      const discount = this.calcDiscountValue(participateDiscountSetItems.length);
      /** 折扣是否生效 */
      const verifyDiscount = this.calcVerifyDiscount(target.currentSet, participateDiscountSetItems, participateDiscountsNoSameProducts, supportSameMultiProduct);
      // 计算价格
      const { price, comparePrice } = this.calculateTotalPrice(target.currentSet, participateDiscountsNoSameProducts, discount);
      this._lastBundlePriceCents = verifyDiscount ? price : comparePrice;

      // 渲染已选产品 Set
      this.renderSetItems(target.currentSet, participateDiscountSetItems, discount, verifyDiscount);
      // 渲染加购按钮
      this.renderAddCartButton(verifyDiscount, target.currentSet.length > 0, price, comparePrice);
      this.renderV2Summary(target.currentSet, verifyDiscount, price, comparePrice);
      // 渲染分期 
      this.klarna?.setAttribute('data-purchase-amount', Math.max(Math.round(price), 1));
      this.paypal?.setAttribute('data-pp-amount', price / 100);
      this.syncBrowserUrlFromSet();
      this.syncFormExpandHeight();
    }

    /**
     * 渲染已选产品 Set
     * @param {SetItem[]} setItems 已选产品项
     * @param {SetItem[]} participateDiscountSetItems 已选 Set 中参与折扣的项
     * @param {number} discount 折扣
     * @param {boolean} verifyDiscount 折扣是否生效
     */
    renderSetItems(setItems, participateDiscountSetItems, discount, verifyDiscount) {
      // 更多 (+号) 标识符
      const addSetItemHTML = `
        <li class="swiper-slide">
          <picture>
            <svg class="icon icon-set-add">
              <use xlink:href="#icon-set-add"></use>
            </svg>
          </picture>
        </li>
      `;
      let setItemsData = { innerHTML: '' };
      for (let i = 0; i < setItems.length; i++) {
        const setItem = setItems[i];
        /** 是否展示折扣角标 */
        const showDiscountBadge = verifyDiscount
          && (participateDiscountSetItems.findIndex((item) => item.id == setItem.id) > -1);
        setItemsData.innerHTML += `
          <li class="swiper-slide" data-index="${i}">
            <picture>
              <img src="${this.insertSizeBeforeExtension(setItem.image, 500)}" width="500" height="500" alt="">
            </picture>
            ${showDiscountBadge ? `
              <span class="diy-bundle__set-item-badge" data-set-item-badge>
                -${discount * 100}%
              </span>`
            : ''}
            <button type="button" aria-label="${this.themeTranslate.remove ?? 'Remove'}" data-set-item-remove>
              <svg class="icon icon-set-remove">
                <use xlink:href="#icon-set-remove"></use>
              </svg>
            </button>
          </li>
        `;
      }
      // 已选产品Set的更多 (+号) 标识符
      const minSetItemSize = this.getMinSetItemSize();
      if (setItems.length < (minSetItemSize - 1)) {
        const offset = minSetItemSize - setItems.length;
        for (let i = 0; i < offset; i++) {
          setItemsData.innerHTML += addSetItemHTML;
        }
      } else {
        setItemsData.innerHTML += addSetItemHTML;
      }
      this.setItemsElement.innerHTML = setItemsData.innerHTML;
    }

    /**
     * 渲染加购按钮
     * @param {boolean} verifyDiscount 折扣是否生效
     * @param {bool} enable 激活按钮
     * @param {number} price 
     * @param {number} comparePrice 
     */
    renderAddCartButton(verifyDiscount, enable, price, comparePrice) {
      enable ? this.addCartButton.removeAttribute('disabled') : this.addCartButton.setAttribute('disabled', '');
      if (verifyDiscount) {
        // 满足折扣
        this.addCartButtonPrice.innerHTML = this.formatMoney(price);
        this.addCartButtonComparePrice.innerHTML = this.formatMoney(comparePrice);
        this.addCartButtonDot?.classList.remove('visually-hidden');
      } else if (enable) {
        // 不折扣，按钮激活
        this.addCartButtonDot?.classList.add('visually-hidden');
        this.addCartButtonPrice.innerHTML = this.formatMoney(comparePrice);
        this.addCartButtonComparePrice.innerHTML = '';
      } else {
        // 不折扣，按钮不激活
        this.addCartButtonDot?.classList.add('visually-hidden');
        this.addCartButtonPrice.innerHTML = '';
        this.addCartButtonComparePrice.innerHTML = '';
      }
    }

    /**
     * 侧栏：件数、节省金额、套装价、按钮文案。
     * 默认样式没有 summary 节点，只更新按钮。
     */
    renderV2Summary(setItems, verifyDiscount, price, comparePrice) {
      const count = setItems.length;
      const textEl = this.querySelector('[data-add-to-cart-text]');
      if (textEl) {
        const ready = this.addCartButton && !this.addCartButton.hasAttribute('disabled');
        textEl.textContent = ready
          ? (this.dataset.readyLabel || textEl.textContent)
          : (this.dataset.incompleteLabel || textEl.textContent);
      }
      if (!this.classList.contains('diy-bundle--v2')) return;
      const countEl = this.querySelector('[data-set-count]');
      if (countEl) {
        const template = this.dataset.countLabel || '{{ count }} items selected';
        countEl.textContent = template.replaceAll('||count||', String(count));
      }
      const savingsEl = this.querySelector('[data-set-savings]');
      const priceEl = this.querySelector('[data-set-price]');
      const savings = verifyDiscount ? Math.max(comparePrice - price, 0) : 0;
      const currentPrice = count > 0 ? (verifyDiscount ? price : comparePrice) : 0;
      if (savingsEl) {
        const money = this.formatMoney(savings);
        savingsEl.innerHTML = money.startsWith('-') ? money : `-${money}`;
      }
      if (priceEl) priceEl.innerHTML = this.formatMoney(currentPrice);
      const helper = this.querySelector('[data-set-helper]');
      if (helper) helper.hidden = count > 0;
    }

    /**
     * 校验是否满足折扣条件
     * @param {SetItem[]} setItems 已选产品项
     * @param {SetItem[]} participateDiscountSetItems 已选 Set 中参与折扣的项
     * @param {string[]} participateDiscountsNoSameProducts 已选 Set 里参与折扣的产品 (排除重复出现的 Product)
     * @param {boolean} supportSameMultiProduct 是否允许多个相同产品参与折扣 (A+A)
     */
    calcVerifyDiscount(setItems, participateDiscountSetItems, participateDiscountsNoSameProducts, supportSameMultiProduct) {
      const productGroups = this.sectionData.groups;
      let verifyDiscount = false;
      /** 最少需要几个参与折扣产品 */
      const minSetItemCountForDiscount = this.sectionData.discount_step[0]?.count ?? 2;
      // verifyDiscount
      if (supportSameMultiProduct) {
        // 允许多个相同产品参与折扣 (A+A) 时, 至少要有x个参与折扣的"不同或相同"产品
        if (participateDiscountSetItems.length >= minSetItemCountForDiscount) {
          // Set 需要选了所有必选的产品组, 且满足每个产品组的必选数量要求，才能生效折扣
          verifyDiscount = productGroups.every(group => group.required
            ? (participateDiscountSetItems.filter((item) => group.products.includes(item.productId)).length >= group.required_size)
            : true)
        }
      } else {
        // 不允许多个相同产品参与折扣 (A+A) 时, 至少要有x个参与折扣的"不同"产品
        if ((participateDiscountsNoSameProducts != undefined) && (participateDiscountsNoSameProducts.length >= minSetItemCountForDiscount)) {
          // Set 需要选了所有必选的产品组, 且满足每个产品组的必选数量要求，才能生效折扣
          verifyDiscount = productGroups.every(group => group.required
            ? (participateDiscountsNoSameProducts.filter((productId) => group.products.includes(productId)).length >= group.required_size)
            : true)
        }
      }
      return verifyDiscount;
    }

    /**
     * 已选产品set中，分离出参与折扣和不参与折扣的项
     * @param {SetItem[]} setItems 已选产品项
     * @param {boolean} supportSameMultiProduct 是否允许多个相同产品参与折扣 (A+A)
     * @returns {FilterParticipateDiscountSetItemsReturn}
     */
    filterParticipateDiscountSetItems(setItems, supportSameMultiProduct = true) {
      if (supportSameMultiProduct) {
        const participateDiscountSetItems = setItems.filter((item) => item.fromGroup.participate_discounts);
        const noParticipateDiscountSetItems = setItems.filter((item) => !item.fromGroup.participate_discounts);
        return { participateDiscountSetItems, noParticipateDiscountSetItems, undefined };
      } else {
        // 已选 Set 里参与折扣的产品 (即排除重复出现的产品)
        const participateDiscountsNoSameProducts = [];
        const participateDiscountSetItems = [];
        const noParticipateDiscountSetItems = [];
        for (const setItem of setItems) {
          if (setItem.fromGroup.participate_discounts && !participateDiscountsNoSameProducts.includes(setItem.productId)) {
            participateDiscountsNoSameProducts.push(setItem.productId);
            participateDiscountSetItems.push(setItem);
          } else {
            noParticipateDiscountSetItems.push(setItem);
          }
        }
        return { participateDiscountSetItems, noParticipateDiscountSetItems, participateDiscountsNoSameProducts };
      }
    }

    /**
     * 根据已选（参加折扣的）产品数量计算折扣额度
     * @param {number} count 已选的产品数量
     * @returns {number} 折扣额度
     */
    calcDiscountValue(count) {
      const step = this.sectionData.discount_step.reduce((pre, curr) => count >= curr.count ? curr : pre, undefined);
      if (step != undefined) {
        return step.discount;
      }
      return 0;
    }

    /**
     * 已选产品Set最小展示数量
     * [data-set-items]>li
     */
    getMinSetItemSize() {
      // v2 移动端空 Set 固定展示 4 个占位，不沿用 v1 的 3 个
      if (this.classList.contains('diy-bundle--v2') && window.innerWidth <= 767) {
        return 4;
      }
      if (window.innerWidth < 590 || (window.innerWidth <= 1180 && window.innerWidth > 767)) {
        return 3;
      }
      return 4;
    }

    // 媒体查询切换至PC端
    mediaChangeToPc() {
      this.destorySetItemsSwiper();
      this.clearFormExpandHeight();
    }

    // 媒体查询切换至移动端
    mediaChangeToMobile() {
      this.createSetItemsSwiper();
      this.syncFormExpandHeight();
    }

    toggleFormExpand(e) {
      e?.preventDefault();
      if (!this.isMobileMQL?.matches || !this.formContainer) return;
      const willExpand = !this.formContainer.classList.contains('expanded');
      this.setFormExpanded(willExpand, true);
    }

    /**
     * 移动端按标题栏 / 完整内容设置悬浮表单高度，并做 height 过渡。
     * 展开动画结束后移除内联 height，以便宽度变化时自适应。
     * @param {boolean} expanded
     * @param {boolean} [animate=true]
     */
    setFormExpanded(expanded, animate = true) {
      const form = this.formContainer;
      const target = this.expandToggleTarget;
      if (!form) return;

      this.cancelFormHeightTransition();
      this.expandToggleButton?.setAttribute('aria-expanded', String(expanded));

      if (!this.isMobileMQL?.matches) {
        form.classList.toggle('expanded', expanded);
        this.clearFormExpandHeight();
        return;
      }

      const collapsedHeight = target?.offsetHeight || 0;
      const startHeight = form.offsetHeight;

      form.classList.toggle('expanded', expanded);

      if (expanded && !animate) {
        this.clearFormExpandHeight();
        this.setItemsSwiper?.update?.();
        return;
      }

      let endHeight = collapsedHeight;
      if (expanded) {
        const prevHeight = form.style.height;
        form.style.height = 'auto';
        endHeight = form.scrollHeight;
        form.style.height = prevHeight || `${startHeight}px`;
      }

      if (!animate) {
        form.style.transition = 'transform 0.3s';
        form.style.height = `${endHeight}px`;
        form.offsetHeight;
        form.style.transition = '';
        return;
      }

      form.style.height = `${startHeight}px`;
      form.offsetHeight;
      form.style.height = `${endHeight}px`;

      if (expanded) {
        this.setItemsSwiper?.update?.();
        this.onFormHeightTransitionEnd(() => {
          if (!form.classList.contains('expanded')) return;
          form.style.height = '';
        });
      }
    }

    onFormHeightTransitionEnd(callback) {
      const form = this.formContainer;
      if (!form) return;

      const token = ++this._formExpandToken;
      const done = () => {
        if (token !== this._formExpandToken) return;
        this._formExpandToken += 1;
        this.cancelFormHeightTransition();
        callback();
      };

      const onEnd = (e) => {
        if (e.target !== form || e.propertyName !== 'height') return;
        done();
      };

      form.addEventListener('transitionend', onEnd);
      const timeoutId = window.setTimeout(done, 350);
      this._formHeightTransitionCleanup = () => {
        form.removeEventListener('transitionend', onEnd);
        window.clearTimeout(timeoutId);
        this._formHeightTransitionCleanup = undefined;
      };
    }

    cancelFormHeightTransition() {
      this._formExpandToken = this._formExpandToken || 0;
      this._formHeightTransitionCleanup?.();
    }

    /** 按当前 expanded 状态同步高度（内容变化或切到移动端时）。 */
    syncFormExpandHeight() {
      if (!this.formContainer) return;
      if (!this.isMobileMQL?.matches) {
        this.clearFormExpandHeight();
        return;
      }
      const expanded = this.formContainer.classList.contains('expanded');
      this.setFormExpanded(expanded, false);
    }

    clearFormExpandHeight() {
      if (!this.formContainer) return;
      this.formContainer.style.height = '';
      this.formContainer.style.transition = '';
    }

    createSetItemsSwiper() {
      this.setItemsSwiper = new Swiper(this.setItemsSwiperElement, {
        loop: false,
        spaceBetween: 0,
        slidesPerView: 'auto',
        observer: true,
        resizeObserver: true,
        scrollbar: {
          el: this.setItemsSwiperElement?.querySelector('.swiper-scrollbar'),
          draggable: true,
        }
      });
    }

    destorySetItemsSwiper() {
      if (this.setItemsSwiper) this.setItemsSwiper.destroy();
    }

    /** Your Set 轮播滑到最后一项（新加入后可见）。 */
    slideSetItemsToLast() {
      const swiper = this.setItemsSwiper;
      if (!swiper) return;

      const goLast = () => {
        swiper.update();
        const lastIndex = Math.max(0, (swiper.slides?.length || 0) - 1);
        swiper.slideTo(lastIndex);
      };

      requestAnimationFrame(() => {
        requestAnimationFrame(goLast);
      });
    }

    /**
     * 计算价格
     * @param {SetItem[]} setItems 已选产品项
     * @param {string[]} participateDiscountsNoSameProducts 已选 Set 里参与折扣的产品 (排除重复出现的 Product)
     * @param {number} discount 折扣率 eg. 0.4
     * @returns {{price:number, comparePrice:number}} 展示的折后价和划线价
     */
    calculateTotalPrice(setItems, participateDiscountsNoSameProducts, discount) {
      /** 已选 Set 里所有产品的原总价, 即 Set 原本应该花费的价格 */
      let fullPrice = 0;
      /** 已选 Set 里排除掉不参与折扣的产品, 剩余参与折扣产品的原总价 */
      let participateDiscountsPrice = 0;
      /** 已选 Set 里排除掉不参与折扣的产品, 剩余参与折扣产品的原总价 (排除重复出现的 Product) */
      let participateDiscountsNoSameProductsPrice = 0;

      // 计算价格、产品等
      for (const setItem of setItems) {
        fullPrice += setItem.variant.price;
        if (setItem.fromGroup && setItem.fromGroup.participate_discounts) {
          // 统计价格
          participateDiscountsPrice += setItem.variant.price;
          // 统计不重复且参与折扣的产品和价格
          if (participateDiscountsNoSameProducts && !participateDiscountsNoSameProducts.includes(setItem.productId)) {
            participateDiscountsNoSameProductsPrice += setItem.variant.price;
          }
        }
      }

      const discountPercent = discount * 100;
      const price = (participateDiscountsPrice * (100 - discountPercent)) / 100 + (fullPrice - participateDiscountsPrice);
      return {
        price: price,
        comparePrice: fullPrice,
      }
    }

    /**
     * 加购
     * @param {[{id: string, quantity: number}]} items 
     */
    async addToCart(items) {
      let formData = {
        'items': items
      };
      return fetch(window.Shopify.routes.root + "cart/add.js",
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(formData),
        }
      ).then((response) => {
        if (response.ok) {
          return response.json();
        }
      }).catch((err) => {
        console.error(err);
      });
    }

    formatMoney(integerPrice) {
      return themeVendor.themeCurrency.formatMoney(integerPrice, theme.moneyFormat);
    }

    /**
     * 在文件扩展名小数点前插入 _${size}x, 例如 _500x
     * @param {string} url 
     * @param {number} size 
     * @returns {string}
     */
    insertSizeBeforeExtension(url, size = 500) {
      if (!url) return url;
      return url.replace(/^([^?#]+)(\.[a-zA-Z0-9]+)([?#].*)?$/, function (_, prefix, ext, suffix) {
        return prefix + `_${size}x` + ext + (suffix || '');
      });
    }

    /**
     * 当一个产品同时存在于多个选项组时，优先匹配必选组
     * @param {string|number} productId
     * @returns {ProductsGroup | undefined}
     */
    findGroupForProduct(productId) {
      const filterGroups = (this.sectionData.groups ?? []).filter((group) =>
        group.products.some((id) => id == productId)
      );
      let findGroup = filterGroups.length > 0 ? filterGroups[0] : undefined;
      for (const group of filterGroups) {
        if (findGroup && !findGroup.required && group.required) {
          findGroup = group;
        }
      }
      return findGroup;
    }

    /**
     * @param {object} variant
     * @param {object} product
     * @returns {string}
     */
    getSetItemImage(variant, product) {
      const variantImage = variant?.featured_image;
      if (typeof variantImage === 'string' && variantImage) return variantImage;
      if (variantImage?.src) return variantImage.src;
      if (variant?.featured_media?.preview_image?.src) return variant.featured_media.preview_image.src;
      const productImage = product?.featured_image;
      if (typeof productImage === 'string' && productImage) return productImage;
      if (productImage?.src) return productImage.src;
      return product?.featured_media?.preview_image?.src ?? '';
    }

    /**
     * @param {string|number} variantId
     * @param {object} product
     * @param {object} variant
     * @returns {SetItem}
     */
    createSetItem(variantId, product, variant) {
      const productId = product?.id;
      return {
        id: `${Date.now()}__${Math.random()}`,
        variantId: variantId,
        image: this.getSetItemImage(variant, product),
        productId: productId,
        variant: variant,
        fromGroup: this.findGroupForProduct(productId),
      };
    }

    /**
     * @param {string} raw
     * @returns {string}
     */
    normalizeShopifyVariantIdParam(raw) {
      if (raw == null || raw === '') return '';
      const s = String(raw).trim();
      const m = s.match(/ProductVariant\/(\d+)/);
      return m ? m[1] : s;
    }

    /**
     * @param {string} variantsParam
     * @returns {string[]}
     */
    parseVariantsQueryParam(variantsParam) {
      if (!variantsParam || typeof variantsParam !== 'string') return [];
      return variantsParam
        .split(',')
        .map((segment) => this.normalizeShopifyVariantIdParam(segment))
        .filter(Boolean);
    }

    /**
     * 页面上的产品卡片 JSON，用于按变体 ID 还原 Your Set
     * @returns {object[]}
     */
    getProductCatalog() {
      if (this._productCatalog) return this._productCatalog;
      const catalog = [];
      const seen = new Set();
      this.querySelectorAll('[data-grid-product-json]').forEach((el) => {
        try {
          const product = JSON.parse(el.textContent);
          if (product?.id != null && !seen.has(String(product.id))) {
            seen.add(String(product.id));
            catalog.push(product);
          }
        } catch (error) {
          console.warn('getProductCatalog', error);
        }
      });
      this._productCatalog = catalog;
      return catalog;
    }

    /**
     * @param {string|number} variantId
     * @returns {{ product: object, variant: object } | null}
     */
    findProductAndVariantByVariantId(variantId) {
      const needle = String(variantId);
      for (const product of this.getProductCatalog()) {
        const variant = product.variants?.find((v) => String(v.id) === needle);
        if (variant) return { product, variant };
      }
      return null;
    }

    /**
     * 重建 query：保留其它参数；`variants` 的逗号不编码
     * @param {string} searchWithOptionalQuestionMark
     * @param {string} variantsRaw
     * @returns {string}
     */
    buildSearchStringWithRawVariantsValue(searchWithOptionalQuestionMark, variantsRaw) {
      const raw = searchWithOptionalQuestionMark || '';
      const qs = raw.startsWith('?') ? raw.slice(1) : raw;
      const src = new URLSearchParams(qs);
      const parts = [];
      src.forEach((v, k) => {
        if (k === 'variants') return;
        parts.push(`${encodeURIComponent(k)}=${encodeURIComponent(v)}`);
      });
      if (variantsRaw != null && variantsRaw !== '') {
        parts.push(`variants=${variantsRaw}`);
      }
      return parts.length ? parts.join('&') : '';
    }

    /**
     * Your Set 变化时同步地址栏：?variants=变体ID,变体ID,...（允许重复；其它 query 保留）
     */
    syncBrowserUrlFromSet() {
      if (typeof history === 'undefined' || typeof history.replaceState !== 'function') return;
      try {
        const url = new URL(window.location.href);
        const variantsRaw = (this.ref?.currentSet ?? this._refOrigin.currentSet)
          .map((item) => this.normalizeShopifyVariantIdParam(item.variantId))
          .filter(Boolean)
          .join(',');
        const newSearch = this.buildSearchStringWithRawVariantsValue(url.search, variantsRaw);
        url.search = newSearch;
        if (url.href !== window.location.href) {
          history.replaceState({}, '', url.href);
        }
        this.syncBundleVirtualSkuFromSelection();
      } catch (err) {
        console.warn('syncBrowserUrlFromSet', err);
      }
    }

    getBundleTrackingVariantIds() {
      return (this.ref?.currentSet ?? this._refOrigin.currentSet)
        .map((item) => String(item.variantId ?? ''))
        .filter(Boolean);
    }

    syncBundleVirtualSkuFromSelection() {
      const api = window.BundleVirtualSkuTracking;
      if (!api?.resolveVirtualSKU) return;
      api.resolveVirtualSKU(this.getBundleTrackingVariantIds(), false);
    }

    trackBundleVirtualSkuAddToCart() {
      const api = window.BundleVirtualSkuTracking;
      if (!api?.trackAddToCartIfValid) return;
      api.trackAddToCartIfValid({
        variantIds: this.getBundleTrackingVariantIds(),
        isTheme: false,
        bundlePriceCents: this._lastBundlePriceCents,
        bundleName: window.__productData?.bundleName,
      });
    }

    /**
     * 首屏根据 ?variants=变体ID,... 还原 Your Set（允许同一变体多次出现）
     * @returns {boolean}
     */
    applySetFromUrl() {
      try {
        const url = new URL(window.location.href);
        const variantsParam = new URLSearchParams(url.search).get('variants');
        if (!variantsParam) return false;
        const ids = this.parseVariantsQueryParam(variantsParam);
        if (ids.length === 0) return false;

        const setItems = [];
        for (const variantId of ids) {
          const found = this.findProductAndVariantByVariantId(variantId);
          if (!found?.variant || !found?.product) continue;
          const item = this.createSetItem(variantId, found.product, found.variant);
          if (!item.fromGroup) continue;
          setItems.push(item);
        }
        this._refOrigin.currentSet = setItems;
        return setItems.length > 0;
      } catch (e) {
        console.warn('applySetFromUrl', e);
        return false;
      }
    }
  });
}

if (!customElements.get('diy-bundle-products')) {
  customElements.define('diy-bundle-products', class DiyBundleProducts extends HTMLElement {
    constructor() {
      super();
      this.swiperELement = this.querySelector(`.swiper`);
      this.layoutPc = this.getAttribute('data-layout-pc');
      this.layoutMb = this.getAttribute('data-layout-mb');

      // 仅首屏：把 URL ?variants= 对应的产品提前，并切到指定变体。后续改 Your Set 不再重排。
      const pending = this.prioritizeProductsFromUrl();
      if (pending && typeof pending.then === 'function') {
        pending.finally(() => this.clearUtmLoading());
      } else {
        this.clearUtmLoading();
      }

      const isMobile = '(max-width: 767px)';
      const isMobileMQL = window.matchMedia(isMobile);
      this.isMobileMQL = isMobileMQL;
      isMobileMQL.addEventListener('change', (event) => {
        event.matches ? this.mediaChangeToMobile() : this.mediaChangeToPc();
      });
      if ((isMobileMQL.matches && this.layoutMb == 'slider')
        || (!isMobileMQL.matches && this.layoutPc == 'slider')) {
        this.createSwiper();
      }
    }

    /**
     * 按进入页面时 URL 中的 variants 顺序，将本组内对应产品卡片移到前面，并切到指定变体。
     * 未命中的产品保持原相对顺序；同一产品只提前一次（用该产品在 URL 中首次出现的变体）。
     * @returns {Promise<void>|void}
     */
    prioritizeProductsFromUrl() {
      const wrapper = this.querySelector('.swiper-wrapper');
      if (!wrapper) return;

      let variantIds = [];
      try {
        const variantsParam = new URLSearchParams(window.location.search).get('variants');
        if (!variantsParam) return;
        variantIds = variantsParam
          .split(',')
          .map((segment) => {
            const s = String(segment || '').trim();
            const gid = s.match(/ProductVariant\/(\d+)/);
            return gid ? gid[1] : s;
          })
          .filter(Boolean);
      } catch (error) {
        console.warn('[DiyBundleProducts] parse variants', error);
        return;
      }
      if (variantIds.length === 0) return;

      const slides = Array.from(wrapper.querySelectorAll(':scope > .swiper-slide'));
      if (slides.length === 0) return;

      const productIdByVariantId = new Map();
      for (const slide of slides) {
        const jsonEl = slide.querySelector('[data-grid-product-json]');
        if (!jsonEl?.textContent) continue;
        try {
          const product = JSON.parse(jsonEl.textContent);
          const productId = product?.id != null ? String(product.id) : '';
          if (!productId) continue;
          for (const variant of product.variants || []) {
            if (variant?.id != null) productIdByVariantId.set(String(variant.id), productId);
          }
        } catch (error) {
          console.warn('[DiyBundleProducts] product json', error);
        }
      }

      const seenProductIds = new Set();
      const priorityProductIds = [];
      const variantIdByProductId = new Map();
      for (const variantId of variantIds) {
        const productId = productIdByVariantId.get(String(variantId));
        if (!productId || seenProductIds.has(productId)) continue;
        seenProductIds.add(productId);
        priorityProductIds.push(productId);
        variantIdByProductId.set(productId, variantId);
      }
      if (priorityProductIds.length === 0) return;

      const rankByProductId = new Map(priorityProductIds.map((id, index) => [id, index]));
      slides.sort((a, b) => {
        const aId = a.querySelector('[data-grid-item]')?.getAttribute('data-grid-item');
        const bId = b.querySelector('[data-grid-item]')?.getAttribute('data-grid-item');
        const aRank = rankByProductId.has(String(aId)) ? rankByProductId.get(String(aId)) : Number.POSITIVE_INFINITY;
        const bRank = rankByProductId.has(String(bId)) ? rankByProductId.get(String(bId)) : Number.POSITIVE_INFINITY;
        if (aRank !== bRank) return aRank - bRank;
        return Number(a.getAttribute('data-slide-index')) - Number(b.getAttribute('data-slide-index'));
      });

      const fragment = document.createDocumentFragment();
      slides.forEach((slide) => fragment.appendChild(slide));
      wrapper.appendChild(fragment);

      return this.applyUrlVariantsToGridItems(slides, variantIdByProductId);
    }

    /**
     * 将排序后的卡片切到 URL 指定变体。优先走 ProductGridItemV3.selectVariantById。
     * @param {Element[]} slides
     * @param {Map<string, string>} variantIdByProductId
     * @returns {Promise<void>|void}
     */
    applyUrlVariantsToGridItems(slides, variantIdByProductId) {
      const apply = () => {
        for (const slide of slides) {
          const gridItem = slide.querySelector('product-grid-item-v3');
          if (!gridItem || typeof gridItem.selectVariantById !== 'function') continue;
          const productId = gridItem.getAttribute('data-grid-item');
          const variantId = variantIdByProductId.get(String(productId));
          if (!variantId) continue;
          gridItem.selectVariantById(variantId);
        }
      };

      if (customElements.get('product-grid-item-v3')) {
        apply();
        return;
      }
      return customElements.whenDefined('product-grid-item-v3').then(apply);
    }

    /** 本组排序完成后，若同模块内所有产品组都已处理完，则去掉 loading--utm。无 variants 时也会移除。 */
    clearUtmLoading() {
      const root = this.closest('diy-bundle');
      if (!root) return;
      this._utmProductsReady = true;
      const groups = root.querySelectorAll('diy-bundle-products');
      const allReady = Array.from(groups).every((el) => el._utmProductsReady);
      if (allReady) root.classList.remove('loading--utm');
    }

    mediaChangeToMobile() {
      if (this.layoutPc != this.layoutMb) {
        this.layoutMb == 'slider' ? this.createSwiper() : this.mySwiper.destroy();
      }
    }

    mediaChangeToPc() {
      if (this.layoutPc != this.layoutMb) {
        this.layoutPc == 'grid' ? this.mySwiper.destroy() : this.createSwiper();
      }
    }

    createSwiper() {
      this.mySwiper = new Swiper(this.swiperELement, {
        loop: false,
        speed: 700,
        slidesPerView: 'auto',
        observer: true,
        resizeObserver: true,
        navigation: {
          nextEl: this.querySelector(`.swiper-button-next`),
          prevEl: this.querySelector(`.swiper-button-prev`),
        },
        scrollbar: {
          el: this.querySelector('.swiper-scrollbar'),
          draggable: true,
        },
      });
    }
  });

  document.querySelectorAll('diy-bundle').forEach((el) => {
    el.classList.remove('loading--utm');
  });
}